var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState, } from "../../../../recoil/menuState";
import { getApiLangState } from "../../../../recoil/langState";
// img, css etc
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
// components
import EhpImageCrop from "../../../common/imagecrop/EhpImageCrop";
import EhpPostCode from "../../../common/postcode/EhpPostCode";
//component
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ZoneInsert(props) {
    //recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //
    //첨부 이미지 처리 ref
    const fileRef = useRef();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    /// company list
    const [companyList, setCompanyList] = useState([]);
    const { data: retList, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/companies`,
        appQuery: {},
        language: apiLang,
        userToken: userInfo.loginInfo.token,
        watch: ""
    });
    useEffect(() => {
        if (retList) {
            if (retList.codeNum == CONST.API_200) {
                //clog("IN COMPANY LIST : RES : " + JSON.stringify(retList.data.page));
                setCompanyList(retList.body.map((comp) => (Object.assign(Object.assign({}, comp), { "autofield": comp.companyName }))));
            }
        }
    }, [retList]);
    const [autoCompanyInfo, setAutoCompanyInfo] = useState(null);
    function resetAutoCompanyInfo() {
        setAutoCompanyInfo(null);
        resetCompanyInfo();
    }
    const [companyInfo, setCompanyInfo] = useState({
        "companyId": "",
        "companyName": "",
        "url": "",
        "businessNo": "",
        "administrator": "",
        "classification": "",
        "accountManager": "",
        "accMngrTelephone": "",
        "interfaceInfo": "",
        "memo": ""
    });
    const { data: data, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/${selTree.company.companyId}`,
        appQuery: {},
        language: apiLang,
        userToken: userInfo.loginInfo.token,
        watch: selTree.company.companyId
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyInfo(data.body);
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data]);
    const resetCompanyInfo = () => (setCompanyInfo({
        "companyId": "",
        "companyName": "",
        "url": "",
        "businessNo": "",
        "administrator": "",
        "classification": "",
        "accountManager": "",
        "accMngrTelephone": "",
        "interfaceInfo": "",
        "memo": ""
    }));
    const [zoneInfo, setZoneInfo] = useState({
        "zoneName": "",
        "address": "",
        "memo": "",
        "assessmentScore": 70,
    });
    // comment 길이 제한 콜백 함수
    function callbackSetZoneInfoMemo(val) {
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: val }));
    }
    function callbackSetZoneInfoAddress(val) {
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { address: val }));
    }
    const [errorList, setErrorList] = useState([]);
    // called by AutoComplete
    /*   async function handleSetAutoComplete(autoInfo) {
        if (CUTIL.isnull(autoInfo)) return;
        setAutoCompanyInfo(autoInfo);
        setRecoilIsLoadingBox(true);
        const data = await HTTPUTIL.PromiseHttp({
          httpMethod: "GET",
          appPath: `/api/v2/product/company/${autoInfo.companyId}`,
          appQuery: {},
          userToken: userInfo.loginInfo.token, // url 직접 접근시 로그인 정보 사라짐..
          watch : autoInfo.companyId
        });
        if (data) {
          if (data.codeNum == CONST.API_200) {
            clog("COMP INFO : " + JSON.stringify(data.body));
            setErrorList([]);
            setCompanyInfo(data.body);
          } else { // api if need error handle
            setErrorList(data.body.errorList);
          }
        }
        setRecoilIsLoadingBox(false);
      }
     */
    function onClickZoneList(e) {
        setParentWorkMode("LIST");
    }
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [cropedImage, setCropedImage] = useState(null);
    useEffect(() => {
        setParentPopWin("pop-imgcrop", React.createElement(EhpImageCrop, { cropImage: selectedFiles, setCropedImage: handleSetCropedImage }));
    }, [selectedFiles]); // selected files이 변경될때마다...이미지 반영을 위해
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        setParentPopWin("pop-postcode", React.createElement(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetZoneInfoAddress }));
    });
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
    }
    // 로컬 파일 URL을 통해 파일 객체 데이터 화
    function handleSetCropedImage(cropVal) {
        //clog("save croped file : " + JSON.stringify(cropVal));
        //var imgDataUrl = sigCanvas.toDataURL('image/png');
        var binaryData = atob(cropVal.url.split(',')[1]);
        var array = [];
        for (var i = 0; i < binaryData.length; i++) {
            array.push(binaryData.charCodeAt(i));
        }
        var file = new File([new Uint8Array(array)], cropVal.name, { type: 'image/png' });
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            fileId: "INS_0",
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        setCropedImage(fileVal);
    }
    ;
    // 파일 선택창 업로드
    function onClickFileAdd(e) {
        clog("onClickFileAdd : " + "");
        fileRef.current.value = "";
        fileRef.current.setAttribute("data-pop", "pop-imgcrop"); // data-pop 사라지는 듯....
        fileRef.current.click();
    }
    // 파일 선택창에서 파일 선택시, 처리 기능
    function onChangeFileSelected(e) {
        clog("save attach file : " + JSON.stringify(e.target.files[0]));
        const files = e.target.files;
        const formData = new FormData();
        formData.append("files", files[0]);
        var fileVal = {
            fileId: "INS_0",
            name: files[0].name,
            url: URL.createObjectURL(files[0]),
            type: "INS",
            fileForm: formData,
        };
        setSelectedFiles(fileVal);
        // pop-up 오픈
        CUTIL.jsopen_Popup(e);
    }
    ;
    function onClickSaveCompanyZone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            /*
            let data: any = null;
            setRecoilIsLoadingBox(true);
            data = await HTTPUTIL.PromiseHttp({
              "httpMethod": "POST",
              "appPath": `/api/v2/product/company/zone`,
              appQuery: {
                "companyId": companyInfo.companyId,
                "zoneName": zoneInfo.zoneName,
                "address": zoneInfo.address,
                "memo": zoneInfo.memo
              },
              userToken: userInfo.loginInfo.token,
            });
            if (data) {
              if (data.codeNum == CONST.API_200) {
                clog("IN ZONE CREATE : " + JSON.stringify(data.body));
                if ( cropedImage ) {
                  saveAttachFiles(data.body.zoneId, cropedImage.fileForm);
                }
                setParentSelTree("ZONE",
                  { ...selTree,
                    company : {"companyId":companyInfo.companyId, "companyName":companyInfo.companyName},
                    zone : {"zoneId":data.body.zoneId, "zoneName":data.body.zoneName},
                  }
                );
               setParentWorkMode("READ");
              } else { // api if
                // need error handle
                setErrorList(data.body.errorList);
              }
            }
            setRecoilIsLoadingBox(false);
            */
        });
    }
    function onClickDoSaveZone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone`,
                appQuery: {
                    "companyId": companyInfo.companyId,
                    "zoneName": zoneInfo.zoneName,
                    "address": zoneInfo.address,
                    "memo": zoneInfo.memo,
                    "assessmentScore": zoneInfo.assessmentScore,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE CREATE : " + JSON.stringify(data.body));
                    if (cropedImage) {
                        saveAttachFiles(data.body.zoneId, cropedImage.fileForm);
                    }
                    setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": companyInfo.companyId, "companyName": companyInfo.companyName }, reload: true }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    function saveAttachFiles(zoneId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone/images?zoneId=${zoneId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE CREATE : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    /// default select box handler
    // option 선택 시  값 변경 액션
    function selectOptionScore(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        clog("IN SELECT OPTION SCROE : " + optionData);
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { assessmentScore: parseInt(optionData) }));
    }
    function onClickDoCancelZone(e) {
        setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": selTree.company.companyId, "companyName": selTree.company.companyName }, reload: true }));
        setParentWorkMode("READ");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype", ref: mobileRef },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00")),
            React.createElement("div", { className: "content__info" },
                React.createElement("h3", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit star" }, "\uD68C\uC0AC \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp4", value: companyInfo.companyName, disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp5", value: companyInfo.url, disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp6", value: companyInfo.businessNo, disabled: true }))))),
            React.createElement("div", { className: "content__info" },
                React.createElement("div", { className: "column" },
                    React.createElement("h3", null, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uC785\uB825"),
                    React.createElement("div", { className: "flex-row" },
                        React.createElement("div", { className: "img_workplace" },
                            React.createElement("div", { className: "btn-imgadd" },
                                React.createElement("label", { onClick: (e) => onClickFileAdd(e) },
                                    React.createElement("span", { className: "hide" }, "\uC0AC\uC9C4\uCCA8\uBD80")),
                                React.createElement("input", { type: "file", id: "img", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => onChangeFileSelected(e) })),
                            React.createElement("div", { id: "image_preview" }, (cropedImage)
                                ? React.createElement("img", { src: cropedImage.url, alt: cropedImage.name })
                                : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" }))),
                        React.createElement("ul", { className: "form__input ml-40" },
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "inp2", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "zoneName")).length > 0) ? "input-error" : "", value: zoneInfo.zoneName, onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { zoneName: e.target.value })) }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "zoneName")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C1"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: "box__search" },
                                        React.createElement("input", { type: "text", placeholder: "\uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: zoneInfo.address, disabled: true }),
                                        React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-postcode", 
                                            //onClick={(e)=>CUTIL.jsopen_Popup(e)}  
                                            onClick: (e) => onClickPostCode(e) },
                                            React.createElement("span", { className: "hide" }, "\uC870\uD68C"))),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "address")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: zoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetZoneInfoMemo), onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: e.target.value })) }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))),
                            React.createElement("li", { className: "mt-40" },
                                React.createElement("p", { className: "tit" }, "\uC9C4\uB2E8 \uC810\uC218 \uAE30\uC900"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: "result__score" },
                                        React.createElement("p", { className: "tit caution" }, "Warning"),
                                        React.createElement("div", { className: "score" },
                                            React.createElement("div", { className: "select w64", onClick: (e) => CUTIL.onClickSelect(e, selectOptionScore) },
                                                React.createElement("div", { className: "selected" },
                                                    React.createElement("div", { className: "selected-value" }, zoneInfo.assessmentScore),
                                                    React.createElement("div", { className: "arrow" })),
                                                React.createElement("ul", null,
                                                    React.createElement("li", { className: "option", "data-value": "50" }, "50"),
                                                    React.createElement("li", { className: "option", "data-value": "55" }, "55"),
                                                    React.createElement("li", { className: "option", "data-value": "60" }, "60"),
                                                    React.createElement("li", { className: "option", "data-value": "65" }, "65"),
                                                    React.createElement("li", { className: "option", "data-value": "70" }, "70"),
                                                    React.createElement("li", { className: "option", "data-value": "70" }, "70"),
                                                    React.createElement("li", { className: "option", "data-value": "75" }, "75"),
                                                    React.createElement("li", { className: "option", "data-value": "80" }, "80"),
                                                    React.createElement("li", { className: "option", "data-value": "85" }, "85"),
                                                    React.createElement("li", { className: "option", "data-value": "90" }, "90"))))))),
                            React.createElement("li", { className: "mt-60" },
                                React.createElement("div", { className: "btn__wrap right w100p" },
                                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickDoCancelZone(e) },
                                        React.createElement("span", null, "\uCDE8\uC18C")),
                                    React.createElement("button", { type: "button", onClick: (e) => onClickDoSaveZone(e) },
                                        React.createElement("span", { "data-pop": "pop-workplace" }, "\uCD94\uAC00")))))))))));
}
;
export default ZoneInsert;
